import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
const resources = {
  pt: {
    translation: {
      'Disponibilidade': 'Disponibilidade',
      'Detalhes': 'Detalhes',
      'Início': 'Início' // Adicione mais traduções conforme necessário

    }
  },
  en: {
    translation: {
      'Disponibilidade': 'Availability',
      'Detalhes': 'Details',
      'Início': 'Home' // Add more translations as needed

    }
  }
};
i18n.use(initReactI18next).init({
  resources,
  lng: 'pt',
  fallbackLng: 'pt',
  interpolation: {
    escapeValue: false
  }
});
export default i18n;
